import {
  IP_ORGANISMOS_TABLE_COLUMNS,
  IP_ORGANISMOS_EXPORT_COLUMNS,
} from '../components/table/ip-organismos-table.constants'

export const ipOrganismosTableDataPreparation = ({ data, combos, intl }) => {
  return data.map((item) => {
    const formattedDates = {}
    const formattedText = {}
    IP_ORGANISMOS_TABLE_COLUMNS.forEach((column) => {
      if (column.type === 'date' && item[column.field]) {
        formattedDates[column.field] = intl.formatDate(item[column.field])
      }
      if (column.multiple && Array.isArray(item[column.field]) && item[column.field].length > 0) {
        const itemValues = item[column.field].map(({ nombre }) => nombre)
        formattedText[column.field] = itemValues.join(', ')
      }
      if (column.field === 'estado') {
        if (['41', '50'].includes(item[column.field])) {
          formattedText[column.field] = 'Validado y cargado en sistema'
        }
      }
    })
    return {
      ...item,
      ...formattedDates,
      ...formattedText,
    }
  })
}

export const ipOrganismosExportDataPreparation = ({ data, combos, intl }) => {
  const formattedData = data.map((item) => {
    const formattedText = {}
    IP_ORGANISMOS_EXPORT_COLUMNS.forEach((column) => {
      if (column.exportType === 'date' && item[column.field]) {
        const date = new Date(item[column.field])
        formattedText[column.field] = intl.formatDate(date)
      }
      if (column.field === 'estado') {
        if (['41', '50'].includes(item[column.field])) {
          formattedText[column.field] = 'Validado y cargado en sistema'
        }
      }
    })
    return {
      ...item,
      ...formattedText,
    }
  })
  return formattedData
}
